import type { RppgScanAbortSource } from './types';

const RUNTIME_DEVICE_ABORT_SOURCES = new Set<RppgScanAbortSource>([
  'device_health',
  'camera_interrupt',
  'low_fps',
]);

export function isRuntimeDeviceAbortSource(
  source: RppgScanAbortSource | undefined,
): boolean {
  return source != null && RUNTIME_DEVICE_ABORT_SOURCES.has(source);
}
